import clsx from 'classnames';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import _ from 'lodash';
import { claimTextMapping, getYesNoLabel } from '../../../../utils/appUtils';
import { ReadOnlyCard } from './RenewalComponents';

const P100RenewalSecurityQuestions = ({ data }: any) => {
  const classes = useStyles();

  return (
    <ReadOnlyCard>
        <Grid container className="card-container" direction="column">
          <Grid item md={12}>
            <div className="flex--spaced">
              <h3 className={clsx('contrast-text', classes.miniheading)}>
                Security Questions
              </h3>
            </div>
          </Grid>
          <Grid item md={12}>
            <Grid container className="card-container" direction="row">
              <LeftColumn data={data} />
              <RightColumn data={data} />
            </Grid>
          </Grid>
        </Grid>
      </ReadOnlyCard>
  );
};

const LeftColumn = ({ data }: any) => {
  const classes = useStyles();

  return (
    <Grid item md={6} className={classes.border}>
      <Grid container direction="row" md={12}>
        <Grid item md={12}>
          <Grid container direction="row">
            <Grid item md={8}>
              <span>Have you ever had any cyber insurance claim(s)?</span>
            </Grid>
            <Grid item md={4}>
              <span className={classes.textInfo}>
                {claimTextMapping[_.get(data, 'claimHistory', 0)]}
              </span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container direction="row">
            <Grid item md={8}>
              <span>
                Does your organization have a Designated Information Security
                Contact?
              </span>
            </Grid>
            <Grid item md={4}>
              <span className={classes.textInfo}>
                {getYesNoLabel(_.get(data, 'isSecurityOfficer', '-'))}
              </span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container direction="row">
            <Grid item md={8}>
              <span>
                Does the organization provide mandatory information security
                training to all employees at least annually? If not, are they
                willing to implement it during the policy period?
              </span>
            </Grid>
            <Grid item md={4} direction="column">
              <span className={classes.textInfo}>
                {getYesNoLabel(_.get(data, 'isSecurityTraining', '-'))}
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const RightColumn = ({ data }: any) => {
  const classes = useStyles();

  return (
    <Grid item md={6}>
      <Grid
        style={{ padding: '0rem 2.083rem' }}
        container
        direction="row"
        md={12}
      >
        <Grid item md={12}>
          <Grid container direction="row">
            <Grid item md={8}>
              <span>
                Does the organization encrypt emails, mobile and computing
                devices containing sensitive information (e.g., PII, PHI, PCI)
                sent to external parties?
              </span>
            </Grid>
            <Grid item md={4}>
              <span className={classes.textInfo}>
                {getYesNoLabel(_.get(data, 'useEncryption', '-'))}
              </span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container direction="row">
            <Grid item md={8}>
              <span>
                Does the organization have sensitive information stored on the
                cloud?
              </span>
            </Grid>
            <Grid item md={4}>
              <span className={classes.textInfo}>
                {getYesNoLabel(_.get(data, 'useCloudStorage', '-'))}
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(({ config, palette }) => ({
  border: {
    borderRight: `solid ${palette.primary.contrastText} 1px`,
    paddingLeft: '2.083rem !important',
  },
  textInfo: {
    color: palette.primary.contrastText,
  },
  miniheading: {
    fontWeight: config.weights.bold,
    fontSize: '2.083rem',
    paddingLeft: '2.083rem',
    marginBottom: '0.875rem',
    marginTop: '0.875rem',
  },
}));

export default P100RenewalSecurityQuestions;
